import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { Breakpoints } from 'utils/const.styles';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2rem;
	width: 100%;
	padding: 1rem;
	.hidden {
		display: none;
	}
`;

export const CardContent = styled.div`
	display: flex;
	flex-direction: column;
	padding: 2rem;
	gap: 2rem;
	overflow: auto;
`;

export const Row = styled.div`
	display: flex;
	flex-direction: row;
	gap: 2rem;

	.integer-input-container {
		width: 100%;
	}

	.time-input {
		width: 100%;
	}

	${(props) =>
		props.isError &&
		css(`
	  display: grid;
    grid-template-columns: 1fr 1fr; 
    grid-template-rows: 1.9fr 0.1fr; 
    gap: 0px 2rem;
    grid-auto-flow: column;
	`)}
`;

export const CheckboxContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 0.7rem;

	input[type='checkbox'] {
		min-width: 2rem;
	}

	${(props) =>
		props.isError &&
		css`
			label {
				color: var(--red);
			}
		`}
`;

export const Column = styled.div`
	display: flex;
	width: 33%;
	flex-direction: column;

	.range {
		padding-inline: 0;
	}

	@media ${Breakpoints.tablet} {
		width: 50%;
	}

	@media ${Breakpoints.mobile} {
		width: 100%;
	}

	.range-slider {
		width: 98%;
	}
`;

export const Divider = styled.div`
	border-bottom: 1px solid var(--border-color);
	margin: 2.581rem 0;
`;

export const DeliverySlotWrapper = styled.div`
	display: flex;
	gap: 1rem;
	flex-direction: column;

	.tag {
		gap: 0.5rem;
	}
`;

export const TagsContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 1rem;
`;

export const CutoffTimeWrapper = styled.div`
	display: flex;
	flex-direction: row;
	gap: 1rem;
`;

export const RangeContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2rem;
	width: 100%;
`;

export const BlackText = styled.span`
	color: var(--black);
	font-weight: 500;
`;
